@let umgebungen = daten().umgebungen;
@let stufen = daten().stufen;
<section>
  <h2 class="np-spalte__titel" data-testid="np-spalte-titel">{{ 'projektNeu.umgebungen.titel' | translate }}</h2>
  <p class="np-spalte__text" data-testid="np-spalte-text">{{ 'projektNeu.umgebungen.text' | translate }}</p>
  <div class="np-zeilen">
    @for (u of umgebungen; track u.schluessel; let i = $index) {
      @let anzeige = u.name || ('projektNeu.umgebungen.ohneName' | translate);
      <div class="np-zeile">
        <mat-form-field appearance="fill" subscriptSizing="dynamic" class="np-feld np-feld--umgebung">
          <input
            matInput
            data-testid="np-umgebung-name"
            [ngModel]="u.name"
            [attr.maxlength]="100"
            [attr.aria-label]="'projektNeu.umgebungen.nameLabel' | translate: { nr: i + 1 }"
            [errorStateMatcher]="fehlerMatcher(i)"
            (ngModelChange)="umgebungAendern(i, { name: $event })"
          />
          @if (doppelt().has(i)) {
            <mat-error>{{ 'projektNeu.umgebungen.doppelt' | translate }}</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill" subscriptSizing="dynamic" class="np-feld np-feld--breit">
          <input
            matInput
            data-testid="np-umgebung-url"
            [value]="u.url"
            [attr.maxlength]="2048"
            [placeholder]="'projektNeu.umgebungen.adressePlatzhalter' | translate"
            [attr.aria-label]="'projektNeu.umgebungen.adresseLabel' | translate: { name: anzeige }"
            (input)="umgebungAendern(i, { url: wert($event) })"
          />
        </mat-form-field>
        <button
          type="button"
          class="np-x"
          data-testid="np-umgebung-entfernen"
          [disabled]="umgebungen.length <= 1"
          [attr.aria-label]="'projektNeu.umgebungen.entfernen' | translate: { name: anzeige }"
          (click)="umgebungEntfernen(i)"
        >
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </div>
    }
  </div>
  <button
    type="button"
    class="np-textknopf np-textknopf--gross np-hinzufuegen"
    data-testid="np-umgebung-hinzufuegen"
    (click)="umgebungHinzufuegen()"
  >
    {{ 'projektNeu.umgebungen.hinzufuegen' | translate }}
  </button>
</section>

<section>
  <h2 class="np-spalte__titel" data-testid="np-spalte-titel">{{ 'projektNeu.teststufen.titel' | translate }}</h2>
  <p class="np-spalte__text" data-testid="np-spalte-text">{{ 'projektNeu.teststufen.text' | translate }}</p>
  <div class="np-zeilen">
    @for (s of stufen; track $index; let i = $index) {
      @let anzeige = s.name || ('projektNeu.teststufen.ohneName' | translate);
      <div class="np-zeile np-zeile--stufe">
        <button
          type="button"
          role="checkbox"
          class="np-haekchen"
          data-testid="np-stufe-an"
          [class.np-haekchen--an]="s.an"
          [attr.aria-checked]="s.an"
          [attr.aria-label]="'projektNeu.teststufen.vorschlagen' | translate: { name: anzeige }"
          (click)="stufeAendern(i, { an: !s.an })"
        >
          @if (s.an) {
            <mat-icon aria-hidden="true">check</mat-icon>
          }
        </button>
        <mat-form-field
          appearance="fill"
          subscriptSizing="dynamic"
          class="np-feld np-feld--breit np-feld--stufe"
          [class.np-feld--aus]="!s.an"
        >
          <input
            matInput
            data-testid="np-stufe-name"
            [value]="s.name"
            [attr.maxlength]="100"
            [placeholder]="'projektNeu.teststufen.platzhalter' | translate"
            [attr.aria-label]="'projektNeu.teststufen.nameLabel' | translate: { nr: i + 1 }"
            (input)="stufeAendern(i, { name: wert($event) })"
          />
        </mat-form-field>
        <mat-form-field
          appearance="fill"
          subscriptSizing="dynamic"
          class="np-feld np-feld--auswahl np-feld--umgebung-wahl"
        >
          <mat-select
            data-testid="np-stufe-umgebung"
            [value]="s.umgebung"
            [disabled]="!s.an"
            [placeholder]="'projektNeu.teststufen.umgebungWaehlen' | translate"
            [aria-label]="'projektNeu.teststufen.umgebungLabel' | translate: { name: anzeige }"
            (selectionChange)="stufeAendern(i, { umgebung: $event.value })"
          >
            @for (u of umgebungen; track u.schluessel) {
              <mat-option [value]="u.schluessel">
                {{ u.name || ('projektNeu.umgebungen.ohneName' | translate) }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button
          type="button"
          class="np-x"
          data-testid="np-stufe-entfernen"
          [disabled]="stufen.length <= 1"
          [attr.aria-label]="'projektNeu.teststufen.entfernen' | translate: { name: anzeige }"
          (click)="stufeEntfernen(i)"
        >
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </div>
    }
  </div>
  <button
    type="button"
    class="np-textknopf np-textknopf--gross np-hinzufuegen"
    data-testid="np-stufe-hinzufuegen"
    (click)="stufeHinzufuegen()"
  >
    {{ 'projektNeu.teststufen.hinzufuegen' | translate }}
  </button>
</section>
